export default function LPBottomDivider(props) {
  return (
    <svg viewBox="0 0 1366.4 213" {...props}>
      <path fill="#ba5d72" d="M-.4 91.8l238.7 83L1052 86.1l314.6-1.3v128H0z" />
    </svg>
  );
}
